import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updatePassword } from "../utilities/RegisterUtils";
import "./Login.css";

export default function UpdatePassword() {
  const [userData, setUserData] = useState({
    old: "",
    password: "",
    confirmPassword: "",
  });
  const loc = useLocation();
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [focusedField, setFocusedField] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    toast.error(`Error: Your password has expired. Please update.`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }, []);

  const styles = {
    inputStyle: {
      color: "whitesmoke",
      borderRadius: "0.5rem",
      width: "22rem",
      fontSize: "14px",
    },
  };

  const updatePasswordCall = async () => {
    const payload = {
      username: loc?.state.email,
      old_password: userData?.old,
      new_password: userData?.password,
    };

    try {
      const data = await updatePassword(payload);
      if (data?.success === true) {
        navigate("/login");
      } else {
        return;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validate = (data) => {
    let tempErrors = {};
    let isValid = true;

    if (data.password === "") {
      tempErrors.password = "Password is required.";
      isValid = false;
    } else {
      if (data.password.length < 10 || data.password.length > 20) {
        tempErrors.password = "Password must be between 10 and 20 characters.";
        isValid = false;
      }
      if (!/[a-z]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one lowercase letter.";
        isValid = false;
      }
      if (!/[A-Z]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one uppercase letter.";
        isValid = false;
      }
      if (!/[0-9]/.test(data.password)) {
        tempErrors.password = "Password must contain at least one number.";
        isValid = false;
      }
      if (!/[!*^$@#%&)(]/.test(data.password)) {
        tempErrors.password =
          "Password must contain at least one special character.";
        isValid = false;
      }
      if (/\s/.test(data.password)) {
        tempErrors.password = "Password cannot contain spaces.";
        isValid = false;
      }
      if (/(\S)\1/.test(data.password)) {
        tempErrors.password =
          "Password cannot contain consecutive repeated characters.";
        isValid = false;
      }
    }

    if (data.confirmPassword !== data.password) {
      tempErrors.confirmPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (isFormValid) {
      console.log("Form is valid. Proceed with registration.");
    }
    updatePasswordCall();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newUserData = {
      ...userData,
      [name]: value,
    };
    setUserData(newUserData);

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setIsFormValid(validate(newUserData));
  };

  const handleFocus = (e) => {
    setFocusedField(e.target.name);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  useEffect(() => {
    setIsFormValid(validate(userData));
  }, [userData]);

  return (
    <div>
      <img
        src="/images/carpl_background.png"
        alt="carpl-background"
        style={{ position: "absolute", width: "100%", opacity: "0.4" }}
      ></img>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ position: "relative", left: "0rem", top: "5rem" }}
      >
        <div className="login-img-data">
          <div>
            <img src="images/carpl_logo.png" alt="Logo" />
          </div>

          <div className="login-header-data">
            Global Platform for Development, Testing & Deployment of Advanced
            Radiology Analytics
          </div>
        </div>

        <div className="login-form-container">
          <div className="login-register-heading">UPDATE PASSWORD</div>
          <div className="input-container">
            <div className="password-container d-flex justify-content-start align-items-center input-field-login">
              <div className="d-flex justify-content-start align-items-center ">
                <div className="icon-input-field">
                  <i className="fa fa-unlock-alt" aria-hidden="true" />
                </div>
                <div className="input-width-22rem">
                  <TextField
                    autoFocus
                    size="small"
                    id="old"
                    value={userData.old}
                    name="old"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Old Password"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ width: "22rem" }}
                    InputProps={{
                      style: styles.inputStyle,
                    }}
                  />
                </div>
              </div>
              <div className="toggleView ">
                <i
                  className={!showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                  id="togglePassword"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleClickShowPassword}
                />
              </div>
            </div>
            {focusedField === "old" && errors.old && (
              <p className="error-span">{errors.old}</p>
            )}

            <div className="password-container d-flex justify-content-start align-items-center input-field-login">
              <div className="d-flex justify-content-start align-items-center ">
                <div className="icon-input-field">
                  <i className="fa fa-unlock-alt" aria-hidden="true" />
                </div>
                <div className="input-width-22rem">
                  <TextField
                    autoFocus
                    size="small"
                    id="password"
                    value={userData.password}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ width: "22rem" }}
                    InputProps={{
                      style: styles.inputStyle,
                    }}
                  />
                </div>
              </div>
              <div className="toggleView ">
                <i
                  className={!showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                  id="togglePassword"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleClickShowPassword}
                />
              </div>
            </div>
            {focusedField === "password" && errors.password && (
              <p className="error-span">{errors.password}</p>
            )}

            <div className="password-container d-flex justify-content-start align-items-center input-field-login">
              <div className="d-flex justify-content-start align-items-center ">
                <div className="icon-input-field">
                  <i className="fa fa-unlock-alt" aria-hidden="true" />
                </div>
                <div className="input-width-22rem">
                  <TextField
                    autoFocus
                    size="small"
                    id="confirmPassword"
                    value={userData.confirmPassword}
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    style={{ width: "22rem" }}
                    InputProps={{
                      style: styles.inputStyle,
                    }}
                  />
                </div>
              </div>
              <div className="toggleView ">
                <i
                  className={
                    !showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"
                  }
                  id="toggleConfirmPassword"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleClickShowConfirmPassword}
                />
              </div>
            </div>
            {focusedField === "confirmPassword" && errors.confirmPassword && (
              <p className="error-span">{errors.confirmPassword}</p>
            )}
          </div>

          <button
            className="register-button"
            onClick={handleSubmit}
            disabled={!isFormValid}
          >
            <span>UPDATE PASSWORD</span>
          </button>
          <div className="register-text-container">
            <span style={{ color: "white" }}>Already Updated &nbsp;?</span>
            <Link
              to="/Login"
              className="register-text"
              style={{
                color: "#00c9d0",
                textDecoration: "none",
                marginLeft: "0.5rem",
              }}
            >
              Click to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
